// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lc7l","left":"styles_left__2vHO3"};